import { render, staticRenderFns } from "./header-v2.vue?vue&type=template&id=8033fb18&scoped=true&"
import script from "./header-v2.vue?vue&type=script&lang=js&"
export * from "./header-v2.vue?vue&type=script&lang=js&"
import style0 from "./header-v2.vue?vue&type=style&index=0&id=8033fb18&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8033fb18",
  null
  
)

export default component.exports